export default "__VITE_ASSET__BjTT01cg__"